import { SignupConversionRow } from '../types';

/**
 * The five stages a funnel passes through, in order. Expired is not one of them: it is where a funnel ended,
 * and it has already been counted in every stage it did pass.
 */
export const SignupStages = [
  { key: 'started', label: 'Started' },
  { key: 'verified', label: 'Email verified' },
  { key: 'reachedCard', label: 'Reached payment' },
  { key: 'paid', label: 'Paid' },
  { key: 'completed', label: 'Completed' },
] as const;

export type SignupStageKey = (typeof SignupStages)[number]['key'];

/**
 * Measured against the funnels that started rather than against the stage before, because a funnel is
 * counted in every stage it has been through — the stages are steps down from the top, not slices of a whole.
 */
export function stageShare(row: SignupConversionRow, key: SignupStageKey): number {
  return row.started == 0 ? 0 : row[key] / row.started;
}

export function formatShare(share: number): string {
  return `${Math.round(share * 100)}%`;
}
